import { CadNextNotification, CadNextNotificationPriorityEnumType } from '@mark43/cad-api';

export function highestNotificationPriorityForNotifications(
    notifications: CadNextNotification[]
): CadNextNotificationPriorityEnumType | undefined {
    let ret: CadNextNotificationPriorityEnumType | undefined = undefined;
    for (const notification of notifications) {
        if (notification.notificationPriority === 'HIGH') return 'HIGH';
        if (notification.notificationPriority === 'STANDARD') {
            ret = 'STANDARD';
        }
    }
    return ret;
}
